var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "controlItem"
  }, [_c("div", {
    staticClass: "nameBox",
    class: _vm.isShow ? "name2" : ""
  }, [_vm.item2.other ? _c("span", [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item2.controlExplain) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _vm._v(" : ")], 1), _c("div", {
    staticClass: "contBox"
  }, [_vm.item2.partsType == "singleLine" && _vm.item2.statistical == "amount" ? [_c("a-input", {
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")] : _vm._e(), _vm.item2.partsType == "singleLine" && !_vm.item2.statistical ? _c("a-input", {
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText) + (_vm.item2.promptText == "付款金额" ? "(" + _vm.$t("单位") + ":" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) + ")" : ""),
      readOnly: true
    }
  }) : _vm._e(), _vm.item2.partsType == "multiline" ? _c("a-textarea", {
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  }) : _vm._e(), _vm.item2.partsType == "singleChoice" ? _c("a-radio-group", {
    attrs: {
      value: "",
      disabled: ""
    }
  }, _vm._l(_vm.item2.optionList, function (item3, index3) {
    return _c("a-radio", {
      key: index3,
      attrs: {
        value: item3
      }
    }, [_vm._v(" " + _vm._s(item3) + " ")]);
  }), 1) : _vm._e(), _vm.item2.partsType == "multipleChoice" ? _c("a-checkbox-group", {
    attrs: {
      disabled: "",
      options: _vm.item2.optionList
    }
  }) : _vm._e(), _vm.item2.partsType == "dropDown" ? _c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText)
    }
  }, _vm._l(_vm.item2.optionList, function (item3, index3) {
    return _c("a-select-option", {
      key: index3,
      attrs: {
        value: item3
      }
    }, [_vm._v(" " + _vm._s(item3) + " ")]);
  }), 1) : _vm._e(), _vm.item2.partsType == "hierarchy" && _vm.item2.type == "province" ? _c("area-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText)
    }
  }) : _vm._e(), _vm.item2.partsType == "hierarchy" && _vm.item2.type == "country" ? _c("country", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText)
    }
  }) : _vm._e(), _vm.item2.partsType == "date" && _vm.item2.dateType == 1 || _vm.item2.partsType == "date" && !_vm.item2.dateType ? _c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      format: _vm.getFormatDate()
    }
  }) : _vm._e(), _vm.item2.partsType == "date" && _vm.item2.dateType == 3 ? _c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-time": "",
      format: _vm.getFormatDate() + "HH:mm" + _vm.dateChronaxie()
    }
  }) : _vm._e(), _vm.item2.partsType == "dateRange" && _vm.item2.dateType == 1 || _vm.item2.partsType == "dateRange" && !_vm.item2.dateType ? _c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      format: _vm.getFormatDate()
    }
  }) : _vm._e(), _vm.item2.partsType == "dateRange" && _vm.item2.dateType == 3 ? _c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-time": {
        format: "HH:mm"
      }
    }
  }) : _vm._e(), _vm.item2.partsType == "picture" || _vm.item2.partsType == "enclosure" ? _c("div", {
    staticClass: "pictureBox"
  }, [_c("div", {
    staticClass: "ant-upload ant-upload-select ant-upload-select-picture-card picture"
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  })], 1), _vm.item2.fileFormat.length != 0 ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(_vm.item2.fileFormat.join(",")) + "）")]) : _vm._e(), _vm.item2.template.length != 0 ? _c("div", {
    staticClass: "ant-btn-link",
    staticStyle: {
      cursor: "pointer"
    },
    on: {
      click: function ($event) {
        return _vm.onModalPreview(_vm.item2.template);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("模板预览")) + " ")]) : _vm._e()]) : _vm._e(), _c("div")], 2), _c("preview-list-modal", {
    attrs: {
      previewVisible: _vm.previewListVisible,
      fileList: _vm.modalPreviewList
    },
    on: {
      cancel: function ($event) {
        _vm.previewListVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };